import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'recipes', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent) },
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () => import('./core/layout/layout.component').then((m) => m.LayoutComponent),
    loadChildren: () => import('./core/layout/layout.routes').then((m) => m.layoutRoutes),
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: 'recipes' },
];
